import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './LoginPage.css';
import { useAuth } from '../../components/AuthProvider';
import { useComponentLoading } from '../../utils/useComponentLoading';
import { LoadingSpinner } from '../../components/LoadingSpinner/LoadingSpinner';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();
  const location = useLocation();
  const { withLoading, isLoading } = useComponentLoading();

  const particlesInit = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  const particlesOptions = {
    background: { color: { value: 'transparent' } },
    fpsLimit: 60,
    interactivity: {
      events: {
        onClick: { enable: true, mode: 'push' },
        onHover: { enable: true, mode: 'repulse' },
        resize: true
      },
      modes: {
        push: { quantity: 4 },
        repulse: { distance: 100, duration: 0.4 }
      }
    },
    particles: {
      color: { value: '#000000' },
      links: { color: '#000000', distance: 150, enable: true, opacity: 0.2, width: 1 },
      collisions: { enable: false },
      move: { direction: 'none', enable: true, outModes: { default: 'bounce' }, random: false, speed: 2, straight: false },
      number: { density: { enable: true, area: 800 }, value: 50 },
      opacity: { value: 0.5 },
      shape: { type: 'circle' },
      size: { value: { min: 1, max: 5 } }
    },
    detectRetina: true
  };

  useEffect(() => {
    if (location.state && location.state.error) {
      setError(location.state.error);
      // Clear the error from history so it doesn't persist on refresh
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, location.pathname, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setError("");
    try {
      const success = await withLoading('login', async () => {
        return await login({ email:username,username, password });
      }, 'Logging in...');
      if (success) {
        navigate('/login/home');
      } else {
        throw new Error("Invalid username or password");
      }
    } catch (err) {
      navigate('/', { state: { error: err.message || "Login failed" } });
    }
  };

  return (
    <div className="login-page" style={{ minHeight: "100vh" }}>
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={particlesOptions}
        style={{
          position: "absolute",
          inset: 0,
          zIndex: 0
        }}
      />
      <div className="logo">VendorBooks</div>
      <div className="login-box">
        <form className="login-form" onSubmit={handleLogin} noValidate>
          <h2>Login</h2>
          {error && <p className="error">{error}</p>}
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username/Email"
            required
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
          />
          <button type="submit" className={isLoading('login') ? "submitButton loading" : "submitButton"} disabled={isLoading('login')}>
            {isLoading('login') ? <LoadingSpinner size="small" inline={true} message="" /> : 'Login'}
          </button>
        </form>
      </div>
      <div className="nav-links">
        <a href="/help">Help</a>
        <a href="/discover">Discover</a>
        <a href="/signup">Signup</a>
      </div>
    </div>
  );
}

export default Login;
